/**
 * Voluum Flow mutations
 * For Media Devoted | Created By Ciro Autiero
 *
 * The Voluum-shaped flow writes (voluum-shape-flow-mutations.ts) at
 * /voluum/flows, invalidating the Voluum flow query.
 */

import { voluumKeys } from './useVoluum';
import {
  useFlowItemWeights,
  useFlowPathToggle,
  useFlowPathWeights,
  type FlowMutationTarget,
} from './voluum-shape-flow-mutations';

const VOLUUM_FLOWS: FlowMutationTarget = {
  base: '/voluum/flows',
  flowKey: (flowId) => voluumKeys.flow(flowId),
};

export function useToggleFlowPathStatus() {
  return useFlowPathToggle(VOLUUM_FLOWS);
}

export function useUpdateFlowItemWeights() {
  return useFlowItemWeights(VOLUUM_FLOWS);
}

export function useUpdateFlowPathWeights() {
  return useFlowPathWeights(VOLUUM_FLOWS);
}
